<script>
  import {supportsLogin} from "./services/configService";
  import {slide, fade} from "svelte/transition";
  import {authStore} from "./stores/authStore";

  let showLoginForm = false;
  const collapsedHeight = "5rem";
  const authlog = true;
  let completeHeight = "21rem";
  let height = collapsedHeight;
  let username = "";
  let password = "";

  function handleLogin() {
    authStore.login(username, password);
  }

  function toggleLogin() {
    showLoginForm = !showLoginForm;
  }

  authStore.subscribe((s) => {
    if (s.loggedIn) {
      showLoginForm = false;
    }
  });
  // TODO: unsubscribe

  $: height = showLoginForm ? completeHeight : collapsedHeight;
  $: thereIsErrorLogin = errorLoggingIn($authStore.errorLogin);

  function errorLoggingIn(error) {
    if (error) {
      completeHeight = "24rem";
      height = "24rem";
    }
  }


</script>

{#if supportsLogin()}
  <div
    class="vec-relative  vec-rounded cursor-pointer vec-w-full md:vec-w-72"
    style="height: {collapsedHeight}"
  >
    {#if !$authStore.loggedIn}
      <div
        class="vec-absolute vec-inset-0  vec-w-full bg-product-gradient vec-filter vec-blur-sm vec-z-10 transition-height"
        style="height: {height}"></div>
      <div
        class="vec-absolute vec-bg-white vec-w-full vec-rounded vec-z-20 transition-height"
        style="height: {height}"
      >
        <div
          class=" vec-flex vec-space-x-4 vec-p-4 vec-items-center"
          on:click={toggleLogin}
        >
          <div class="vec-flex vec-flex-col vec-flex-1">
            <span class="vec-font-semibold"> Log in to track your progress </span>
          </div>
          <div class="vec-flex-0 vec-flex-shrink-0">
          <span
            class="vec-inline-block vec-h-12 vec-w-12 vec-rounded-full vec-overflow-hidden vec-bg-gray-100"
          >
            <svg
              class="vec-h-full vec-w-full vec-text-gray-300"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </span>
          </div>
        </div>
        {#if showLoginForm}
          {#if $authStore.loggingIn}
            <div class="vec-flex vec-space-x-4 vec-p-4 vec-items-center justify-content-center h-50"
                 in:fade={{ delay: 200 }}>
              <div class="spinner"></div>
            </div>
          {:else}
            <div class="vec-w-full vec-p-4 vec-space-y-4" in:fade={{ delay: 200 }}>
              {#if $authStore.errorLogin}
                <div in:fade={{ delay: 200 }}>
                  <p class="vec-text-sm text-danger">The details entered do not match our system. Please try again.</p>
                </div>
              {/if}
              <div>
                <label for="tracking_email" class="vec-text-sm  vec-font-semibold"
                >Email Address</label
                >
                <input
                  bind:value={username}
                  type="text"
                  id="tracking_email"
                  placeholder="V&Co Username/Email"
                  class="vec-w-full block"
                />
              </div>

              <div>
                <label for="tracking_password" class="vec-text-sm vec-font-semibold"
                >Password</label
                >
                <input
                  bind:value={password}
                  type="password"
                  id="tracking_password"
                  class="vec-w-full block"
                />
              </div>
              <button
                on:click={handleLogin}
                class="vec-bg-black vec-w-full vec-text-white vec-font-semibold vec-tracking-wide cursor-pointer"
              >Login
              </button
              >
            </div>
          {/if}
        {/if}
      </div>
    {:else}
      <div
        class=" vec-flex vec-space-x-4 vec-p-2 vec-items-center vec-shadow"
      >
        <div class="vec-flex vec-flex-col vec-flex-1">
          <span class="vec-font-semibold vec-text-sm "> Logged in as</span>
          <span class="vec-font-semibold vec-text-sm"> {$authStore.user.email}</span>
        </div>
        <div class="vec-flex-0 vec-flex-shrink-0">
          <span
            class="vec-inline-block vec-h-12 vec-w-12 vec-rounded-full vec-overflow-hidden vec-bg-gray-100"
          >
            <svg
              class="vec-h-full vec-w-full vec-text-gray-300"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </span>
        </div>
      </div>
    {/if}
  </div>
{/if}

<style>
    .bg-product-gradient {
        background-image: linear-gradient(114deg, #ad1f29, #1f4586, #056938);
    }

    .transition-height {
        transition: height 0.3s ease-out;
    }

    .spinner {
        display: inline-block;
        width: 24px;
        height: 24px;
        border: 4px solid rgba(162, 160, 160, 0.1);
        border-radius: 50%;
        border-top-color: #ad1f29;
        /* animation: spin 1s ease-in-out infinite; */
        -webkit-animation: spin 1s linear infinite;
    }

    @keyframes spin {
        25% {
            -webkit-transform: rotate(90deg);
            border-top-color: #1E4583;
            /* border-width: 6px; */
        }
        50% {
            -webkit-transform: rotate(181deg);
            border-top-color: #63A5D6;
            /* border-width: 8px; */
        }
        75% {
            -webkit-transform: rotate(270deg);
            border-top-color: #6EC277;
        }
        100% {
            -webkit-transform: rotate(360deg);
            /* border-width: 6px; */
        }
    }

    @-webkit-keyframes spin {
        25% {
            -webkit-transform: rotate(90deg);
            border-top-color: #1E4583;
            /* border-width: 6px; */
        }
        50% {
            -webkit-transform: rotate(181deg);
            border-top-color: #63A5D6;
            /* border-width: 8px; */
        }
        75% {
            -webkit-transform: rotate(270deg);
            border-top-color: #6EC277;
        }
        100% {
            -webkit-transform: rotate(360deg);
            /* border-width: 6px; */
        }
    }

</style>
